import Vue from 'vue'
import Router from 'vue-router'

import Teamsite from '@/components/Teamsite'
import Cars from '@/components/Cars'
import Redirect from '@/components/Redirect'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'teamsite',
      component: Teamsite,
    },
    {
      path: '/cars',
      name: 'cars',
      component: Cars,
    },
    {
      path: '/data-privacy',
      name: 'data-privacy',
      component: Redirect,
      props: { kind: 'privacyPolicyUrl' }
    },
    {
      path: '/imprint',
      name: 'imprint',
      component: Redirect,
      props: { kind: 'siteNoticeUrl' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js